angular.module('mapes').controller('listVacantsPreinscripcioController', function (
  $scope,
  $uibModalInstance,
  $uibModal,
  ofertaCentreSFP,
  selectedEnsenyaments,
  centre,
  selectorCurs,
  Configuracio,
  SharedProperties,
  selectedApiFilter
) {

  var tornOrdre = {
    MM: { ordre: 1, literal: 'Matí' },
    MT: { ordre: 2, literal: 'Matí i tarda' },
    NA: { ordre: 3, literal: 'NA' },
    TT: { ordre: 4, literal: 'Tarda' },
    VV: { ordre: 5, literal: 'VV' }
  };

  $scope.centre = centre;
  $scope.selectorCurs = selectorCurs;
  $scope.increment = 1;
  $scope.isOferta = false;
  $scope.isProgramacio = false;
  $scope.areBoth = false;
  $scope.teProgramacio = false;
  $scope.displayMoreEnsenyaments = false;
  $scope.tornsDictionary = {
    MT: 'Matí i tarda',
    MM: 'Matí',
    TT: 'Tarda',
  }

  var init = function () {
    if ($scope.selectorCurs === $scope.anyActualString) {
      $scope.isOferta = true;
    } else if ($scope.selectorCurs === $scope.anyActualMesUString) {
      $scope.isProgramacio = true;
    } else {
      $scope.areBoth = true;
    }
    $scope.htmlPreinscripcio = 'Preinscripció';
    $scope.selectedEnsenyaments = selectedEnsenyaments ? selectedEnsenyaments : [];

    var ariFilter = transformAriFilter(selectedApiFilter);
    if (
      (!_.isEmpty(ariFilter.BATX)) ||
      (!_.isEmpty(ariFilter.CFP)) ||
      (!_.isEmpty(ariFilter.EPRI)) ||
      (!_.isEmpty(ariFilter.ESO)) ||
      (!_.isEmpty(ariFilter.EINF)) ||
      (!_.isEmpty(ariFilter.PFI)) ||
      (!_.isEmpty(ariFilter.CFA))
    ) {

      var centresFiltrats = ofertaCentreSFP.centres.filter(function (c) {
        return check(c, ariFilter);
      });

      var intersection = _.intersection(centresFiltrats, ofertaCentreSFP.centres);
      ensenyamentsNoConincidents = _.difference(ofertaCentreSFP.centres, intersection);

      var ensenyamentsCoincidentsAgrupats = _.groupBy(centresFiltrats, 'codPlaEsp');
      var ensenyamentsDiferentsAgrupats = _.groupBy(ensenyamentsNoConincidents, 'codPlaEsp');
      $scope.ensenyamentsSeleccionats = createEnsenyamentObject(ensenyamentsCoincidentsAgrupats);
      $scope.altresEnsenyaments = createEnsenyamentObject(ensenyamentsDiferentsAgrupats);
    } else {
      var ensenyamentsAgrupats = _.groupBy(ofertaCentreSFP.centres, 'codPlaEsp');
      $scope.ensenyaments = createEnsenyamentObject(ensenyamentsAgrupats);
    }

    SharedProperties.closeLoader();
  };

  function check(centre, filtres) {
    var comprovacio = true;

    if (
      !_.isEmpty(filtres[centre.codPla]) ||
      (centre.codPla === 'CFPM' && !_.isEmpty(filtres['CFP'])) ||
      (centre.codPla === 'CFPS' && !_.isEmpty(filtres['CFP'])) ||
      (centre.codPla === 'CFPB' && !_.isEmpty(filtres['CFP'])) ||
      (centre.codPla === 'CFAS' && !_.isEmpty(filtres['CFA'])) ||
      (centre.codPla === 'PFI' && !_.isEmpty(filtres['PFI'])) ||
      (centre.codPla === 'CFAM' && !_.isEmpty(filtres['CFA']))
    ) {
      var filtre = {};

      if (centre.codPla === 'BATX') {
        filtre = filtres.BATX;
      } else if (centre.codPla === 'CFP' || centre.codPla === 'CFPM' || centre.codPla === 'CFPS' || centre.codPla === 'CFPB') {
        filtre = filtres.CFP;
      } else if (centre.codPla === 'EPRI') {
        filtre = filtres.EPRI;
      } else if (centre.codPla === 'ESO') {
        filtre = filtres.ESO;
      } else if (centre.codPla === 'EINF') {
        filtre = filtres.EINF;
      } else if (centre.codPla === 'CFAS' || centre.codPla === 'CFAM') {
        filtre = filtres.CFA;
      } else if (centre.codPla === 'PFI') {
        filtre = filtres.PFI;
      }

      if (filtre.hasOwnProperty('torns') && filtre.torns.length > 0) {
        comprovacio = comprovacio && filtre.torns.includes(centre.torn);
      }
      if (filtre.hasOwnProperty('regims') && filtre.regims.length > 0) {
        comprovacio = comprovacio && filtre.regims.includes(centre.regim);
      }
      if (filtre.hasOwnProperty('nivells') && filtre.nivells.length > 0) {
        comprovacio = comprovacio && filtre.nivells.includes(centre.labelNivell);
      }
      if (filtre.hasOwnProperty('naturaleses') && filtre.naturaleses.length > 0) {
        if (filtre.naturaleses.includes(2) || filtre.naturaleses.includes(3)) {
          comprovacio = comprovacio && (centre.codiNaturalesa === "2" || centre.codiNaturalesa === "3")
        } else {
          comprovacio = comprovacio && filtre.naturaleses.includes(parseInt(centre.codiNaturalesa));
        }
      }
      if (filtre.hasOwnProperty('cicles') && filtre.cicles.length > 0) {
        comprovacio = comprovacio && filtre.cicles.includes(centre.codPla);
      }
      if (filtre.hasOwnProperty('estudis') && filtre.estudis.length > 0) {
        comprovacio = comprovacio && filtre.estudis.includes(centre.codPlaEsp);
      }
      if (filtre.hasOwnProperty('families') && filtre.families.length > 0) {
        comprovacio = comprovacio && filtre.families.includes(centre.codiModalitat);
      }
      if (filtre.hasOwnProperty('tipus') && filtre.tipus.length > 0) {
        if (
          centre.codPla === 'BATX' ||
          centre.codPla === 'CFP' ||
          centre.codPla === 'CFPM' ||
          centre.codPla === 'PFI' ||
          centre.codPla === 'CFPS' ||
          centre.codPla === 'CFPB'
        ) {
          comprovacio = comprovacio && filtre.tipus.includes(centre.codPla);
        } else {
          comprovacio = comprovacio && filtre.tipus.includes(centre.codPlaEsp);
        }
      }
    } else if (
      !_.isEmpty(filtres.BATX) ||
      !_.isEmpty(filtres.CFP) ||
      !_.isEmpty(filtres.EPRI) ||
      !_.isEmpty(filtres.ESO) ||
      !_.isEmpty(filtres.EINF) ||
      !_.isEmpty(filtres.PFI) ||
      !_.isEmpty(filtres.CFA)
    ) {
      comprovacio = false;
    }

    return comprovacio;
  }

  function transformAriFilter(filer) {
    var filtresAgrupatsPerTipus = {};
    filtresAgrupatsPerTipus['EINF'] = {};
    filtresAgrupatsPerTipus['EPRI'] = {};
    filtresAgrupatsPerTipus['ESO'] = {};
    filtresAgrupatsPerTipus['BATX'] = {};
    filtresAgrupatsPerTipus['CFP'] = {};
    filtresAgrupatsPerTipus['CFA'] = {};
    filtresAgrupatsPerTipus['PFI'] = {};

    filer.forEach(function (f) {
      var nouFiltre = {};
      nouFiltre['cicles'] = [];
      nouFiltre['estudis'] = [];
      nouFiltre['families'] = [];
      nouFiltre['naturaleses'] = [];
      nouFiltre['nivells'] = [];
      nouFiltre['torns'] = [];
      nouFiltre['tipus'] = [];
      nouFiltre['regims'] = [];

      if (f.cicles) {
        nouFiltre['cicles'] = filterRepeatedFromStringArray(nouFiltre['cicles'].concat(getCicles(f.cicles)));
      }
      if (f.regims) {
        nouFiltre['regims'] = filterRepeatedFromStringArray(nouFiltre['regims'].concat(getRegim(f.regims)));
      }
      if (f.estudis) {
        nouFiltre['estudis'] = filterRepeatedFromStringArray(nouFiltre['estudis'].concat(getEstudis(f.estudis)));
      }
      if (f.families) {
        nouFiltre['families'] = filterRepeatedFromStringArray(nouFiltre['families'].concat(getFamilies(f.families)));
      }
      if (f.naturaleses) {
        nouFiltre['naturaleses'] = filterRepeatedFromStringArray(nouFiltre['naturaleses'].concat(getNaturaleces(f.naturaleses)));
      }
      if (f.nivells) {
        nouFiltre['nivells'] = filterRepeatedFromStringArray(nouFiltre['nivells'].concat(getNivells(f.nivells)));
      }
      if (f.torns) {
        nouFiltre['torns'] = filterRepeatedFromStringArray(nouFiltre['torns'].concat(getTorns(f.torns)));
      }
      if (f.tipus) {
        if (f.tipus.codi === 'BATXLOE') {
          nouFiltre['tipus'] = nouFiltre['tipus'].concat(['BATX']);
        } else if (f.tipus.codi === 'ESOLOE') {
          nouFiltre['tipus'] = nouFiltre['tipus'].concat(['ESO LOE']);
        } else if (f.tipus.codi === 'EINFLOE3-6') {
          nouFiltre['tipus'] = nouFiltre['tipus'].concat(['EINFLOE 2C']);
        } else if (f.tipus.codi === 'CFP' || f.tipus.codi === 'CFA') {
          if (nouFiltre['families'].length === 0) {
            f.tipus.subnodes.forEach(function (node) {
              nouFiltre['families'].push(node.codi);
            });
          }
        } else {
          nouFiltre['tipus'] = filterRepeatedFromStringArray(nouFiltre['tipus'].concat([f.tipus.codi]));
        }
      }

      if (f.tipus.codi === 'EINFLOE3-6') {
        filtresAgrupatsPerTipus['EINF'] = nouFiltre;
      }
      if (f.tipus.codi === 'EPRILOE') {
        filtresAgrupatsPerTipus['EPRI'] = nouFiltre;
      }
      if (f.tipus.codi === 'ESOLOE') {
        filtresAgrupatsPerTipus['ESO'] = nouFiltre;
      }
      if (f.tipus.codi === 'BATXLOE') {
        filtresAgrupatsPerTipus['BATX'] = nouFiltre;
      }
      if (f.tipus.codi === 'CFP') {
        filtresAgrupatsPerTipus['CFP'] = nouFiltre;
      }
      if (f.tipus.codi === 'PFI') {
        filtresAgrupatsPerTipus['PFI'] = nouFiltre;
      }
      if (f.tipus.codi === 'CFA') {
        nouFiltre.cicles = transformarAciclesArts(nouFiltre.cicles);
        filtresAgrupatsPerTipus['CFA'] = nouFiltre;
      }
    });

    return filtresAgrupatsPerTipus;
  }

  function transformarAciclesArts(ciclesArts) {
    var cicles = [];
    ciclesArts.forEach(function (c) {
      if (c === 'CFPM') {
        cicles.push('CFAM');
      } else if (c === 'CFPS') {
        cicles.push('CFAS');
      } else {
        cicles.push(c);
      }
    });

    return cicles;
  }

  function filterRepeatedFromStringArray(arr) {
    return arr.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
  }

  function getTorns(torns) {
    var arrayTorns = [];
    torns.forEach(function (torn) {
      arrayTorns.push(torn.id);
    });

    return arrayTorns;
  }

  function getNivells(nivells) {
    var arrayNivells = [];
    nivells.forEach(function (nivell) {
      arrayNivells.push(nivell.curso.trim());
    });
    return arrayNivells;
  }

  function getNaturaleces(naturaleces) {
    var arrayNaturaleces = [];
    naturaleces.forEach(function (naturalesa) {
      arrayNaturaleces.push(naturalesa.id);
    });
    return arrayNaturaleces;
  }

  function getFamilies(families) {
    var arrayFamilies = [];
    (families || []).forEach(function (familia) {
      (familia.codis || (familia.codi && [familia.codi]) || []).forEach(function (codi) {
        arrayFamilies.push(codi);
      })
    });
    return arrayFamilies;
  }

  function getEstudis(estudis) {
    var arrayEstudis = [];

    estudis.forEach(function (estudi) {
      if (estudi.hasOwnProperty('codis')) {
        estudi.codis.forEach(function (codi) {
          arrayEstudis.push(codi);
        })
      }
      if (estudi.hasOwnProperty('codi')) {
        arrayEstudis.push(estudi.codi);
      }
    });

    return unificarCodisEstudis(arrayEstudis);
  }

  function getCicles(cicles) {
    var arrayCicles = [];
    cicles.forEach(function (cicle) {
      if (cicle.codi === 'CGGS') {
        arrayCicles.push('CFPS');
      } else if (cicle.codi === 'CGGM') {
        arrayCicles.push('CFPM');
      } else {
        arrayCicles.push(cicle.codi);
      }
    });

    return arrayCicles;
  }

  function getRegim(regims) {
    var arrayRegims = [];
    regims.forEach(function (regim) {
      arrayRegims.push(regim.id);
    });
    return arrayRegims;
  }

  function unificarCodisEstudis(estudis) {
    var estudisCodis = [];
    estudis.forEach(function (item) {
      estudisCodis.push(transformTypus(item));
    });
    return estudisCodis;
  }

  function transformTypus(item) {
    if (item === 'BATXLOE 1000 01') {
      return 'BATXLOE 1000';
    } else if (item === 'BATXLOE 2000' || item === 'BATXLOE 3000' || item === 'BATXLOE 4000') {
      return 'BATXLOE 9999';
    } else {
      return item;
    }
  }

  function isEnsenyamentBatxillerat(codi) {
    return ["BATX"].indexOf(codi) > -1;
  }

  function isEnsenyamentFpOrArtistic(codi) {
    return ["CFPM", "CFAM", "CFPS", "CFAS"].indexOf(codi) > -1;
  }

  function assignTornOrder(ensenyaments) {
    ensenyaments.forEach(function (index) {
      var ensenyament = index;
      if (ensenyament != null) {
        var torn = tornOrdre[ensenyament.torn];
        ensenyament.tornOrdre = torn.ordre;
        ensenyament.tornNom = torn.literal;
      }
    });
  }

  function assignRegimName(ensenyaments) {
    ensenyaments.forEach(function (index) {
      var ensenyament = index;
      if (ensenyament != null && ensenyament['regim'] != null) {
        ensenyament.regimNom = (ensenyament['regim'] === 'DD') ? 'Diürn' : 'Nocturn';
      }
    })
  }

  function createEnsenyamentObject(listEnsenyaments) {
    var ensenyaments = [];
    for (var index in listEnsenyaments) {
      var listEnsenyament = listEnsenyaments[index];
      var ensenyament = {};
      ensenyament.codi = _.first(listEnsenyament).codPla;
      ensenyament.codPlaEsp = _.first(listEnsenyament).codPlaEsp;
      ensenyament.nomEnsenyament = _.first(listEnsenyament).nomEnsenyament;
      ensenyament.modalitat = _.first(listEnsenyament).modalitat;
      ensenyament.ofertaActiva = _.first(listEnsenyament).ofertaActiva;
      ensenyament.sfp = _.first(listEnsenyament).sfp;
      ensenyament.ordre = _.first(listEnsenyament).ordre;
      if (isEnsenyamentBatxillerat(ensenyament.codi)) {
        assignRegimName(listEnsenyament);
        ensenyament.estudis = _.groupBy(_.orderBy(listEnsenyament, 'labelNivell'), 'labelNivell');
      } else if (isEnsenyamentFpOrArtistic(ensenyament.codi)) {
        assignTornOrder(listEnsenyament);
        ensenyament.estudis = _.sortBy(listEnsenyament, ['curs', 'tornOrdre']);
      } else {
        ensenyament.estudis = _.orderBy(listEnsenyament, [function (o) {
          return o.curs;
        }]);
      }
      ensenyaments.push(ensenyament);
    }
    ensenyaments = _.sortBy(ensenyaments, 'ordre');
    return ensenyaments;
  }

  $scope.anyActual = parseInt(Configuracio.getConfiguracio().anyActual, 10);
  $scope.anyActualString = "'" + String($scope.anyActual) + "'";
  $scope.anyActualMesU = $scope.anyActual + $scope.increment;
  $scope.anyActualMesUString = "'" + String($scope.anyActualMesU) + "'";
  $scope.anyActualMesDos = $scope.anyActualMesU + $scope.increment;
  $scope.periodeAct = String($scope.anyActual) + ' - ' + String($scope.anyActualMesU);
  $scope.periodeSeg = String($scope.anyActualMesU) + ' - ' + String($scope.anyActualMesDos);

  init();

  $scope.toggleMesEnsenyaments = function () {
    $scope.displayMoreEnsenyaments = !$scope.displayMoreEnsenyaments;
  };

  $scope.close = function () {
    $uibModalInstance.close();
  };

  $scope.goToCentre = function (centre) {
    if (centre !== undefined) {
      $uibModal.open(
        {
          animation: true,
          component: 'ajFitxaCentre',
          size: 'xl',
          resolve: { centre },
        }
      );
    }
  }
});
